import React, { useRef, useLayoutEffect, useEffect, useState } from 'react';
import { getViewportDimensions } from '../../../../models/Utils';
import { ADAARIARoles } from '../../../../models/ADA';

import './AnimatedNumbers.scss';

const AnimatedNumbers = ({ text, animatedPart }) => {
  const content = useRef(null);
  const animationDone = useRef(false);
  const [initialText, setInitialText] = useState(text);
  const refAnimatedPart = useRef(animatedPart);
  const refText = useRef(text);

  const numberWithCommas = (x) => {
    var parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  };

  const animateNumbers = () => {
    const fixedParts = refText.current.split(refAnimatedPart.current);
    const start = 0;
    const end = parseFloat(refAnimatedPart.current.replace(',', ''));
    const decimalPlaces = refAnimatedPart.current.indexOf('.') > -1 ? refAnimatedPart.current.split('.')[1].length : 0;
    const precision = Math.pow(10, decimalPlaces);
    const exponent = refAnimatedPart.current.replace(',', '').replace('.', '').length * 2;
    const t0 = Date.now();
    const tFinal = t0 + 2000;
    const animate = () => {
      let t = Date.now();
      if (t >= tFinal) t = tFinal;
      let tNormalized = (t - t0) / (tFinal - t0);
      const diff = (end - start) * (1 - Math.pow(1 - tNormalized, exponent)); // easeOutCirc
      content.current.innerHTML = `${fixedParts[0]}${numberWithCommas(Math.round((start + diff) * precision) / precision)}${fixedParts[1]}`;
      if (t < tFinal) {
        requestAnimationFrame(animate);
      }
    };
    requestAnimationFrame(animate);
  };

  const handleScroll = () => {
    if (animationDone.current) {
      // document.body.removeEventListener('scroll', handleScroll);
      return;
    }

    const rect = content.current.getBoundingClientRect();
    const viewport = getViewportDimensions();
    if (rect.y > 0 && rect.y + rect.height < viewport.height) {
      animationDone.current = true;
      animateNumbers();
    }
  };

  useLayoutEffect(() => {
    document.body.addEventListener('scroll', handleScroll);

    return () => {
      document.body.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    if (animatedPart) {
      if (text.indexOf(animatedPart) < 0) {
        throw new Error('The text does not contain the provided animated part');
      }
      setInitialText(text.replace(animatedPart, 0));
      animationDone.current = false;
    } else {
      setInitialText(text);
      animationDone.current = true;
    }
    refText.current = text;
    refAnimatedPart.current = animatedPart;
  }, [text, animatedPart]);

  return (
    <span className="vbn-animated-numbers">
      <span className="vbn-an-ada-content">{text}</span>
      <span className="vbn-an-animated-part" ref={content} aria-hidden={true}>{initialText}</span>
    </span>
  );
};

export default AnimatedNumbers;
